import React from "react";
import { NavLink } from "react-router-dom";
import { Login } from "./Login";
import { Register } from "./Register";

interface AuthPageProps {
  page: string;
}

const AuthPage: React.FC<AuthPageProps> = ({ page }) => {
  const isLogin = page === "login";

  return (
    <div
      className={`eh-page mx-auto py-8 mb-24 px-2 ${
        isLogin ? "max-w-[480px]" : "max-w-[560px]"
      }`}
    >
      <div className="eh-card shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
          Events House
        </p>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          {isLogin ? "Sign in" : "Create account"}
        </h1>
        <p className="text-sm text-slate-600 mb-6 leading-relaxed">
          {isLogin ? (
            <>
              Sign in to register for events, view your orders and tickets, and
              manage your account.
            </>
          ) : (
            <>
              Register to purchase conference tickets, save your registration
              details, and access receipts from your dashboard.
            </>
          )}
        </p>

        {!isLogin && (
          <p className="text-sm text-slate-600 mb-6 pb-6 border-b border-slate-100">
            Already have an account?{" "}
            <NavLink to="/login" className="font-semibold text-slate-900 underline">
              Sign in
            </NavLink>
          </p>
        )}

        {isLogin ? <Login /> : <Register />}

        {isLogin && (
          <p className="text-sm text-slate-600 mt-6 pt-6 border-t border-slate-100">
            Don&apos;t have an account?{" "}
            <NavLink to="/signup" className="font-semibold text-slate-900 underline">
              Create one
            </NavLink>
          </p>
        )}
      </div>

      {!isLogin && (
        <p className="text-xs text-slate-500 text-center mt-4 leading-relaxed">
          After signing up you can request event admin access from your account
          dashboard under Event admin.
        </p>
      )}
    </div>
  );
};

export default AuthPage;
